module.exports = __webpack_public_path__ + "static/media/parking.bde065f3.svg";